import { createQueryKeys } from '@lukemorales/query-key-factory';

import { SupplierSubscriptionReleaseFlagsMessage } from '../../../supplier-subscription-plans/types/SupplierSubscriptionReleaseFlagsMessage';
import { getSupplierSubscriptionPlans } from '../clients/supplierSubscriptionPlans.api';

export const supplierSubscriptionPlans = createQueryKeys('supplierSubscriptionPlans', {
    list: (releaseFlags: SupplierSubscriptionReleaseFlagsMessage) => ({
        queryKey: [releaseFlags],
        queryFn: getSupplierSubscriptionPlans,
    }),
});
